import { Injectable } from '@angular/core';
import { ExportContext, ExportFileFormat, ExportRange, ExportService, ExportTaskProcessor } from 'app/layout/export-overlay';
import { buildQuery, page, seed } from '@albatrosdeveloper/ave-utils-npm/lib/utils/query.util';
import { takeUntil } from 'rxjs';
import get from 'lodash-es/get';
import ceil from 'lodash-es/ceil';
import { format, parseISO } from 'date-fns';
import { WarehouseService } from '../warehouse.service';
import { WarehouseAttributes } from '@albatrosdeveloper/ave-models-package';
import { LOCALIZED_PROPERTIES, WAREHOUSE_EXPORT_ID, WAREHOUSE_TITLE } from './warehouse.constants';
import ShortPlantsAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/configurations/plants/plants-short/plants-short.entity';

@Injectable()
export class WarehouseExport {
  constructor(
    private exportService: ExportService,
    private warehouseService: WarehouseService,
  ) {}

  private transformItem(item: WarehouseAttributes) {
    return {
      externalKeys: get(item, 'externalKeys.code', ''),
      name: get(item, 'name', ''),
      plants: this.getList<ShortPlantsAttributes>(get(item, 'plants', [])),
      company: get(item, 'company.name', ''),
      //priceList: get(item, 'priceList.name',''), descomentar si se requiere
      //discountList: get(item, 'discountList.name', ''), descomentar si se requiere
      status: ExportTaskProcessor.types.ave.status(get(item, 'statusId', '')),
      readOnly: this.setAsReadOnly(get(item, 'readOnly', '')),
    };
  }

  private getList<T extends { name: string }>(items: T[]): string {
    if (!Array.isArray(items) || items.length === 0) return '-';
    return items.map((division) => division.name).join(', ');
  }

  protected setAsReadOnly(value: any) {
    return ExportTaskProcessor.types.boolean(value, { trueText: 'SÍ', falseText: 'NO' });
  }

  export(format: ExportFileFormat, range: ExportRange, totalItems: number, pageSize: number, pageIndex: number) {
    const totalPages = ceil(totalItems / pageSize) + 1;
    this.exportService.task({
      id: WAREHOUSE_EXPORT_ID,
      title: WAREHOUSE_TITLE,
      format: format,
      iterations: range === ExportRange.AllPages ? totalPages : 1,
      start: (ctx: ExportContext) => {
        ctx.processor.localizeItemProperties(WAREHOUSE_TITLE, LOCALIZED_PROPERTIES);
      },
      next: (ctx: ExportContext) => {
        const currentPage = range === ExportRange.AllPages ? ctx.iteration : pageIndex;
        this.warehouseService.findByFilter(buildQuery(
          seed(this.warehouseService.currentFilter), page(currentPage, pageSize)
        ), { contextHeader: 'export' }).pipe(takeUntil(ctx.stopped)).subscribe((response) => {
          get(response, 'data.0.data', []).map((item) => {
            ctx.processor.addToSection(WAREHOUSE_TITLE, this.transformItem(item));
          });
          ctx.next();
        });
      },
    }).start();
  }

  canStartTask() {
    if (this.exportService.taskIsActive(WAREHOUSE_EXPORT_ID)) {
      this.exportService.setVisible(true);
      return false;
    }
    return true;
  }
}
